<template>
  <div class="review-gallery">
    <div class="gallery-grid">
      <div class="gallery-item" v-for="(photo, index) in props.data.photos" :key="index">
        <div class="gallery-img">
          <img :src="photo.url" :alt="photo.desc" loading="lazy" />
          <div class="gallery-overlay">
            <p>{{ photo.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  data: { type: Object, required: true },
  theme: { type: Object, required: true }
});

// 显式使用theme，避免未使用报错
console.log('主题配置备用', props.theme);
</script>

<style scoped lang="scss">
/* 外层容器 */
.review-gallery {
  width: 100%;
}

/* 图片网格布局 */
.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  width: 100%;
}

/* 单个图片项 */
.gallery-item {
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  height: 220px;
  box-shadow: 0 4px 12px rgba(255, 77, 125, 0.1);
  transition: all 0.3s ease;

  /* 图片容器 */
  .gallery-img {
    width: 100%;
    height: 100%;

    /* 图片样式 */
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: all 0.5s ease;
    }
  }

  /* hover覆盖层 */
  .gallery-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(transparent, rgba(0,0,0,0.7));
    color: white;
    padding: 16px;
    opacity: 0;
    transition: opacity 0.3s ease;

    /* 描述文字 */
    p {
      font-size: 14px;
      margin: 0;
    }
  }

  /* hover效果 */
  &:hover {
    transform: translateY(-5px);

    .gallery-img img {
      transform: scale(1.05);
    }

    .gallery-overlay {
      opacity: 1;
    }
  }
}
</style>